import { KeyedMutator, useSWRConfig } from 'swr'

//https://swr.vercel.app/docs/advanced/cache#mutate-multiple-keys-from-regex
export function useMatchMutate(): ({
  pattern
}: {
  pattern: RegExp
}) => Promise<KeyedMutator<Record<string, any>>[]> {
  const { cache, mutate } = useSWRConfig()
  return ({
    pattern
  }: {
    pattern: RegExp | string
  }): Promise<KeyedMutator<Record<string, any>>[]> => {
    if (!(cache instanceof Map)) {
      throw new Error('matchMutate requires the cache provider to be a Map instance')
    }

    const keys: KeyedMutator<Record<string, any>>[] = []
    for (const key of cache.keys()) {
      if (typeof pattern === 'string') {
        key === pattern && keys.push(key)
      } else if (pattern.test(key)) {
        keys.push(key)
      }
    }
    const mutations = keys.map(key => mutate(key))
    return Promise.all(mutations)
  }
}
